<template>
  <div>
    <b-card>
      <div slot="header">
        {{ $lang.add_content_person }}
      </div>
      <LoadingSpinner :loading="loading" :text="$lang.sending_data" />
      <b-col cols="12" md="12" v-show="!loading">
        <label for="">{{ $lang.send_file }}</label>
        <fileDrag
          ref="fileDrag"
          @uploadFile="attachmentTemp"
          :acceptFormats="acceptFormats"
          :acceptFormatsInput="acceptFormatsInput"
          :multiple="true"
          :crop="false"
        />
        <filelistPorgress
          :fileUpload="fileUpload"
          @removeFile="removeFileProgress"
          @getResponseCode="getResponseCode"
          :showButton="false"
          :attachmentTypeId="attachmentTypeId"
        />
      </b-col>
      <b-col xs="12" md="12" class="text-right mt-3">
        <b-button class="mr-2" variant="outline-danger" @click="closeModal">
          <mdicon name="close" size="20" />
          {{ $lang.close }}
        </b-button>
        <b-button
          variant="success"
          @click="submit"
          v-show="!loading && this.responseCode.length"
        >
          <mdicon name="check" size="20" />
          {{ $lang.submitButton }}
        </b-button>
      </b-col>
    </b-card>
  </div>
</template>
<script>
import fileDrag from "@/components/fileManager/fileDrag";
import filelistPorgress from "@/components/fileManager/filelistPorgress";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";
import { generateApiUrl, generateError, toastAlert } from "@/shared/utils";

export default {
  name: "send-file-component",
  inject: ["attachmentTempFinalRepository"],
  components: {
    fileDrag,
    filelistPorgress,
    LoadingSpinner,
  },
  props: {
    code: {
      type: [String, Number],
      default: null,
    },
    attachmentTypeId: {
      type: [String, Number],
      default: null,
    },
    attachmentTypeName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      acceptFormatsInput: "",
      acceptFormats: [
        {
          caption: "عکس",
          value: "10MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
        {
          caption: "ویدیو/صوت",
          value: "50MB",
        },
        {
          caption: "بقیه فایل‌ها",
          value: "10MB",
        },
      ],
      fileUpload: [],
      responseCode: [],
      loading: false,
    };
  },
  methods: {
    pathOr,
    generateApiUrl,
    attachmentTemp(files) {
      this.fileUpload = [...this.fileUpload, ...files];
    },
    removeFileProgress(item) {
      const indexFile = this.fileUpload.indexOf(item);
      const response = this.responseCode.find((x) => x.name == item.name);
      const indexResponse = this.responseCode.indexOf(response);
      this.fileUpload.splice(indexFile, 1);
      this.responseCode.splice(indexResponse, 1);
      this.$refs.fileDrag.$refs.fileupload.value = "";
    },
    getResponseCode(code) {
      this.responseCode = [...code];
    },
    closeModal() {
      this.$emit("closeModal");
    },
    async submit() {
      if (!this.responseCode.length) return;
      try {
        this.loading = true;
        const url = generateApiUrl(["task", "taskUpload"], [this.code]);
        const payload = { files: [] };
        for (const { code } of this.responseCode) {
          payload.files.push({
            code,
            attachment_type_id: this.attachmentTypeId,
            attachment_type_name: this.attachmentTypeName,
          });
        }
        const response = await this.$httpService.post(url, payload);
        const message = pathOr("", ["data", "message"], response);
        toastAlert(message);
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
        this.closeModal();
      }
    },
  },
};
</script>
